import { render, staticRenderFns } from "./NeedLogo.vue?vue&type=template&id=08a6e401&scoped=true"
import script from "./NeedLogo.vue?vue&type=script&lang=js"
export * from "./NeedLogo.vue?vue&type=script&lang=js"
import style0 from "./NeedLogo.vue?vue&type=style&index=0&id=08a6e401&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6e401",
  null
  
)

export default component.exports